import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(() => ({
  root: {
    width: '100%'
  },
  point: {
    width: 6,
    height: 6,
    borderRadius: 3
  }
}))
